import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { WatchOptions } from 'vue';
import InputSelect from '@/components/inputs/InputSelect/InputSelect.vue';
import InputText from '@/components/inputs/InputText/InputText.vue';
import InputRadioButton from '@/components/inputs/InputRadioButton/InputRadioButton.vue';
import { AnswerChoices, CancerFamilyChoices } from '@/models/VariousEnum';
import { FamilyCancer } from '@/models/QuestQuestion';
import { SelectOptionDTO } from '@/models/SelectOptionDTO';

@Component({
  components: {
    InputSelect,
    InputText,
    InputRadioButton,
  },
})
export default class FamilyCancerPart extends Vue {
  @Prop()
  public value!: FamilyCancer;
  @Prop({ default: false })
  public readonly!: boolean;
  @Prop({ default: true })
  public required!: boolean;
  

  public answerChoices: any = AnswerChoices;
  public selectChoices: SelectOptionDTO[] = [];
  public updating?: boolean = false;
  public errorMessage: string = '';
  public error: boolean = false;

  /**
   * Get an array of all the property names from the value prop in lowercase
   */
  get instanceFields(): string[] {
    if (this.value) {
      const fields: string[] = [];
      Object.keys(this.value).forEach(e => fields.push(e.toLowerCase()));
      return fields;
    }
    return [];
  }
  
  /**
   * Get the errors returned by the API corresponding to the model properties
   */
  get errors(): string[] {
    if (this.$store.state.questionnaireValidationErrors) {
      const obj = this.$store.state.questionnaireValidationErrors;
      const errorFields: string[] = [];
      Object.keys(obj).forEach((e) => {
        if (this.instanceFields.includes(e.toLowerCase())) {
          errorFields.push(obj[e].errors);
        }
      });
      return errorFields;
    }

    return [];
  }

  get showMoreQuestions(): boolean {
    return this.value.flagParentBreastCancer === this.answerChoices.Yes;
  }

  get subQuestionRequired(): boolean {
    return this.value.flagParentBreastCancer === this.answerChoices.Yes 
    && !this.value.daughterCancerCode 
    && !this.value.motherCancerCode  
    && !this.value.parentCancerCode 
    && !this.value.sisterCancerCode;
  }

  protected mounted() {
    this.initSelects();
  }

  protected initSelects(): void {
    const option1: SelectOptionDTO = {} as SelectOptionDTO;
    option1.text = 'questionnaire.common.dontKnow';
    option1.value = CancerFamilyChoices.DontKnow;
    this.selectChoices.push(option1);

    const option2: SelectOptionDTO = {} as SelectOptionDTO;
    option2.text = 'questionnaire.common.lessThan50';
    option2.value = CancerFamilyChoices.LessThan50;
    this.selectChoices.push(option2);

    const option3: SelectOptionDTO = {} as SelectOptionDTO;
    option3.text = 'questionnaire.common.moreThan50';
    option3.value = CancerFamilyChoices.MoreThan50;
    this.selectChoices.push(option3);
  }

  protected onMotherSelectChange(selectedValue: string) {
    this.value.motherCancerCode = selectedValue;
  }

  protected onSisterSelectChange(selectedValue: string) {
    this.value.sisterCancerCode = selectedValue;
  }

  protected onDaughterSelectChange(selectedValue: string) {
    this.value.daughterCancerCode = selectedValue;
  }

  protected onOtherSelectChange(selectedValue: string) {
    this.value.parentCancerCode = selectedValue;
  }

  @Watch('value', { deep: true } as WatchOptions)
  protected onValueChanged(value: FamilyCancer, oldValue: FamilyCancer) {
    if (value) {
      this.$emit('input', value);
    }
  }
}
